import { SVGProps } from 'react'

const SvgLongBar = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1"
      height="59"
      viewBox="0 0 1 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line x1="0.5" x2="0.5" y2="59" stroke="#757575" />
    </svg>
  )
}

export default SvgLongBar
